import React from 'react';
import { IonInput, IonButton, IonIcon } from '@ionic/react';
import { connect } from 'react-redux';
import { lockClosed } from 'ionicons/icons';
import { getConfig } from '../../appConfig';
import Layout from '../../components/layout';
import PasswordInput from '../../components/passwordInput';
import { forwardTo, getDefaultRoute, isWebConfig } from '../../lib/utils';
import { loginRequest } from '../../store/actions';
import { withTranslation } from '../../lib/translate';
import Loading from '../../components/spinner';
import { Title, Spacer, NormalText } from '../../components/common';
import { validateForm } from '../../lib/utils';
import SocialLogin from '../../components/SocialLogin';
import './index.css';
import BlockSeparator from '../../components/blockSeparator';
import FieldWrapper from '../../components/fieldWrapper';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      formErrors: {},
    };
    this.handleInput = this.handleInput.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.formConfig = {
      username: { type: 'email', required: true },
      password: { type: 'text', required: true },
    };
  }

  handleInput(key, val) {
    this.setState({ [key]: val });
  }

  handleLogin() {
    let formErrors = validateForm(this.formConfig, this.state);
    this.setState({ formErrors });
    if (Object.keys(formErrors).length === 0) {
      const { protectedReferrer } = this.props;
      let referrer;
			if (this.props?.location?.state?.fromGiftVoucher) {
				referrer = '/gift-vouchers';
			} else if (this.props?.location?.state?.referrer) {
				referrer = this.props?.location?.state?.referrer;
			} else {
				referrer = protectedReferrer;
			}
      const { username, password } = this.state;
      this.props.dispatch(loginRequest({ username, password, referrer, referrerState: this.props?.location?.state?.referrerState }));
    }
  }

  checkLoginStatus = () => {
    const { loggedIn } = this.props.auth;
    if (loggedIn && !this.props?.location?.state?.referrer) {
      const defaultRoute = getDefaultRoute(this.props.navConfig);
      forwardTo(defaultRoute.path);
    }
  };

  componentDidUpdate() {
    this.checkLoginStatus();
  }

  componentDidMount() {
    this.checkLoginStatus();
  }

  render() {
    const { __ } = this.props;
    const { username, password } = this.state;
    let hasSocialLogin = getConfig()?.flags && getConfig().flags.hasSocialLogin;
    const { hideSocialLoginNative } = getConfig()?.socialLogin || {};
    if (!isWebConfig() && hideSocialLoginNative) {
      hasSocialLogin = false
    }
    return (
      <Loading transparent>
        <Layout headerTitle={__('Login')} color="transparent" showHamburger>
          <div className="absolute-content flex-row-wrapper scrollable-y">
            {getConfig().flags.showTabsOnAuthPages ?
              <div className='tabs-title flex-min'>
                <div className={'tab-active'}>
                  <Title >{getConfig().customText?.signIn ? __(getConfig().customText?.signIn) : __('Sign in')}</Title>
                </div>
                <div onClick={() => forwardTo('/register')}>
                  <Title >{getConfig().customText?.signIn ? __(getConfig().customText?.signIn) : __('Sign up')}</Title>
                </div>
              </div>
              :
              <div className="flex-min">
                <Title className='page-title-centered'>{getConfig().customText?.signIn ? __(getConfig().customText?.signIn) : __('Sign in')}</Title>
              </div>
            }
            <div ><div>
              <div className="input-field-container input-field-container-multiple">
                <FieldWrapper error={this.state.formErrors.username}>
                  <IonInput
                    placeholder={__('Email address')}
                    onIonInput={(e) => {
                      this.setState({ formErrors: { ...this.state.formErrors, username: '' }, username: e.target.value })
                    }}
                    clearInput={!this.state.formErrors.username}
                    type="email"
                    pattern="email"
                    inputmode="email"
                    value={username}
                    selenium="email"
                    autocomplete='email'
                  />
                </FieldWrapper>
                <FieldWrapper error={this.state.formErrors.password}>
                  {getConfig().theme.showInputIconsOnLogin ? <IonIcon slot="start" className="login-icon" size="small" icon={lockClosed} /> : null}
                  <PasswordInput showPasswordToggle={!this.state.formErrors.password} placeholder={__('Password')} __={__} onIonChange={(e) => { this.setState({ formErrors: { ...this.state.formErrors, password: '' } }, () => this.handleInput('password', e.target.value)) }} value={password} />
                </FieldWrapper>

              </div>
              <IonButton
                {...(getConfig()?.customButtons?.login && { style: { '--ion-color-primary': getConfig()?.customButtons?.login } })}
                expand="block"
                color="primary"
                className="default-button login-button button-uppercase"
                onClick={() => this.handleLogin()}
              >
                {__('Sign in')}
              </IonButton>
              <Spacer size={5} />
              <IonButton
                expand="block"
                color='secondary'
                className="link"
                onClick={() => forwardTo('/reset-password',{email:this.state.username})}
              >
                {__('Forgot Password?')}
              </IonButton>
              {hasSocialLogin && (
                <div className='social-buttons-wrapper'>
                  <BlockSeparator text='or' />

                  <SocialLogin
                    isRegister={false}
                  />
                </div>
              )}
            </div>
              <div className=" centered">
                <Spacer size={5} />
                <NormalText className="centered block">{__("Don't have an account?")}</NormalText>
                <IonButton
                  color='secondary'
                  className="link"
                  onClick={() => forwardTo('/register')}
                >
                  {__('Sign up')}
                </IonButton>
              </div>
            </div>

          </div>
        </Layout>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  const { auth, protectedReferrer } = state.profile;
  const { storedDeliveryAddress, storedPickUpPoint } = state.orders;
  const { navConfig } = state.common;
  return {
    auth,
    protectedReferrer,
    storedDeliveryAddress,
    storedPickUpPoint,
    navConfig,
  };
};

export default connect(stateToProps)(withTranslation(Login));
